    $(document).ready(function(){
        $('.product__subscription-variant').each(function(i) {
            if($(this).hasClass('active')){
                setTimeout(() => {
                    $(this).trigger('click');
                }, 100);
            }
        })

        $('.product__subscription-variant').on('click', function(){
            let base = $(this).data('base');
            let final = $(this).data('final');
            let basePrice = $(this).data('baseprice');
            let finalPrice = $(this).data('finalprice');
            let discount = $(this).data('discount');
            let append = '';
            if(base > final){
                // append = `
                //     <div class="variant-prices">
                //         <span class="variant-price__base">${basePrice}</span>
                //         <span class="variant-price__final">${finalPrice}</span>
                //     </div>
                //     <span class="variant-discount">${discount}</span>
                // `;
                append = `
                    <div class="variant-prices">
                        <span class="variant-price__base">${basePrice}</span>
                        <span class="variant-price__final">${finalPrice}</span>
                    </div>
                `;
            } else {
                append = '<span class="product__softgel-price">'+ basePrice +'</span>';
            }
            $('.product__softgel-block .product__softgel-price').html(append);
        });

        if($('.product__subscription-variant')) {
            let activeVariant = $('.product__subscription-variant.active');

            let currentType = activeVariant.find('.subscription-variant__input input').attr('data-rc-option');
            switchCartText(currentType);

            $('body').on('click', '.product__subscription-variant', function(){
               $('.product__subscription-variant').removeClass('active');
               $(this).addClass('active');
               let currentType = $(this).find('.subscription-variant__input input').attr('data-rc-option');
               switchCartText(currentType);
            })

            if($('.product__softgel-block').length) {
                           
                let URL = $('.product__softgel-block:not(.active)').attr('href');

                if(!URL.includes('products')) {
                  URL = '/products' + URL;
                }

                $('.product__softgel-block:not(.active)').attr('href', URL)
                
                // there so many applications on PDP so make sure everything is rendered before call
                setTimeout(() => {
                    $.ajax({
                        url: URL,
                        type: 'GET',
                        dataType: 'html',
                        async: false,
                        success: function(responseHTML) {
                            $('.accordeons__multiple_values').each(function(index){
                            $(this).find('.article-value.binded').html($(responseHTML).find('.accordeons__multiple_values').eq(index).find('.article-value.current').html()).show();
                            })
                        }
                
                    })

                }, 7000);
           
            } 

        }

        $('.accordeons .content-entry').click(function(){
            $(this).toggleClass('active');
            $(this).find('.accordion-content').slideToggle()
        })

        $('body').on('click', '.stickyRightHolder .fakeA2C', function(){
            $('product-form form .product-form__submit').click();
        });

        $('.faqOpen').click(function(){
            $(this).hide();
            $(this).parent().find('.faqClose').show();
            $(this).parent().parent().find('.answer').slideDown();
        }) 
        
        $('.faqClose').click(function(){
            $(this).hide();
            $(this).parent().find('.faqOpen').show();
            $(this).parent().parent().find('.answer').slideUp();
        })

        if($(window).width() >= 750) {
            $('body').on('click', '.slider-button--next', function(e){
                e.preventDefault();
                if($('.thumbnail-list.list-unstyled button.thumbnail[aria-current]').parent().index() == $('slider-component .thumbnail-list li:visible').length) {
                    $('thumbnail-list.list-unstyled li').eq(0).find('button.thumbnail').click();
                } else {
                    $('.thumbnail-list.list-unstyled button.thumbnail[aria-current]').parent().nextAll('li:visible').first().find('button').click();
                }
                     
            })

            $('body').on('click', '.slider-button--prev', function(e){
                e.preventDefault();
                if($('.thumbnail-list.list-unstyled button.thumbnail[aria-current]').parent().index() === 0) {
                    $('thumbnail-list.list-unstyled li').eq(0).find('button.thumbnail').click();
                } else {
                    $('.thumbnail-list.list-unstyled button.thumbnail[aria-current]').parent().prevAll('li:visible').first().find('button').click();
                }
                     
            })
        }

        $('body').on('click', '.readLess', function(e){
            $(this).hide();
            $('.readMore').show();
            $('.product__description').addClass('less');
        })

        $('body').on('click', '.readMore', function(e){
            $(this).hide();
            $('.readLess').show();
            $('.product__description').removeClass('less');
        })


    })

    function switchCartText(currentType = 'onetime') {
        const variantPrice = $('.subscription-variant.active .variant-price__final').text();
        if(currentType == 'onetime' || $('.product__info-container .product__title h1').text().includes('Gift')) {

            window.variantStrings.addToCart = 'Add to Cart - ' + variantPrice;
            $('.product-form__submit span').text('Add to Cart - ' + variantPrice);

            $('.fakeATC').text('Add to Cart | ');
         } else {
            window.variantStrings.addToCart = 'Subscribe Now - ' + variantPrice;
            $('.product-form__submit span').text('Subscribe Now - ' + variantPrice);
            $('.fakeATC').text('Subscribe | ');
         }

         let selected = $('.product__subscription-variant.active');

         $('.stickyATC .prodTitle').text(selected.find('.subscription-variant__frequency').text() );

         if(selected.find('.subscription-variant__banner span').length) {
            $('.stickyATC .prodSubTitle').text(selected.find('.subscription-variant__banner span').text());
         } else {
            $('.stickyATC .prodSubTitle').text('');
         }

         $('.stickyRightHolder .fakeValue ').text(selected.find('.variant-price__final').text());

         $('.stickyATC').addClass('show');

    }
